/** Copy tables for the Endocrine Exposure Check. Pure data, no React. */
import type { PresentationBand, ExposureBand } from "./scoring";

/** Meter position + one-line read per exposure band.
 *  Never absolves. ACTIVE is a better position, not a clean bill of health, so
 *  its line names a live exposure and future-paces instead of reassuring. */
export const EXPOSURE_META: Record<ExposureBand, { pos: string; line: string }> = {
  ACTIVE: {
    pos: "25%",
    line: "It is going on him daily, it just has not been running long. That is the best position anyone taking this gets.",
  },
  SUSTAINED: {
    pos: "60%",
    line: "Years deep, and the routine is set. This is where most boys his age land.",
  },
  SATURATED: {
    pos: "88%",
    line: "Stacked products, hot water, years of it, straight through the window that builds him.",
  },
};

/** One-line read per presentation band. Describes her REPORT, never his biology. */
export const PRESENTATION_META: Record<PresentationBand, { line: string }> = {
  ISOLATED: { line: "One thing is showing up, and you noticed it." },
  CLUSTERED: { line: "Several things at once, which is why it stopped adding up for you." },
  BROAD: { line: "It is showing up across most of what you watch for." },
};

/** Brand answer -> how the copy names the villain. */
export const BRAND_LABEL: Record<string, string> = {
  oldspice: "Old Spice",
  axe: "Axe",
  dovemen: "Dove Men",
  store: "the store brand",
  natural: "the natural brand",
  mix: "whatever is on sale",
  noidea: "his current wash",
};

/** Want answer -> the "Plan focus" tile on the result page. */
export const PLAN_FOCUS: Record<string, string> = {
  energy: "His energy",
  drive: "His drive",
  body: "His build",
  confidence: "His confidence",
  clean: "A clean routine",
};